export default __webpack_public_path__ + "static/datadog-5049c32dd99f5dcc4f67429d3bd0e3c0.svg";